import React, { useState } from "react";
import { Stack } from "@mui/material";
import { Settings } from "@mui/icons-material";
import AdminCalendar from "./calendar/AdminCalendar";

const AdminCalendarPanel = ({
  unavailableDates,
  bookedDateRanges, // Updated from bookedDates to bookedDateRanges
  availableWeekdays,
  onDateSelect,
  setShowDateDetails,
  setSelectedDateStr,
}) => {
  // Internal state for highlighted date
  // the initiql vqlue is not really selected, but it is used to highlight the current date in the calendar
  const [highlightedDate, setHighlightedDate] = useState(new Date());

  // Handle date change internally
  const handleDateChange = (date) => {
    setHighlightedDate(date);
    // Pass the selected date up to parent
    onDateSelect(date);
  };

  // Show weekday settings internally
  const handleShowWeekdaySettings = () => {
    setShowDateDetails(true);
    setSelectedDateStr("weekday-settings");
  };

  return (
    <Stack direction="column" alignItems="center" spacing={2}>
      <AdminCalendar
        unavailableDates={unavailableDates}
        bookedDateRanges={bookedDateRanges} // Updated prop name
        availableWeekdays={availableWeekdays}
        onDateChange={handleDateChange}
        highlightedDate={highlightedDate}
        isAdminView={true} // Special flag for admin view
      />
      <button
        onClick={handleShowWeekdaySettings}
        style={{
          width: "70%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ff9800",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "10px 16px",
          marginTop: "16px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        <Settings style={{ marginRight: "8px", fontSize: "18px" }} />
        Paramètres des jours de la semaine
      </button>
    </Stack>
  );
};

export default AdminCalendarPanel;
